import { PresentationMode } from '../../Enums/PresentationMode';
import { modalType } from './OpenedModalType';

export const teamPageReducerTypes = {
  foundTeamResult: 'foundTeamResult',
  notFoundTeamResult: 'notFoundTeamResult',
  setErrorData: 'setErrorData',
  setOpenedModal: 'setOpenedModal',
  updateTeamInfo: 'updateTeamInfo',
  setDefaultAgent: 'setDefaultAgent',
  updateAddressInfo: 'updateAddressInfo',
  updateStateAfterCreateTeam: 'updateStateAfterCreateTeam',
  deepLinkErrorPage: 'deepLinkErrorPage',
  deepLinkErrorResult: 'deepLinkErrorResult',
};

export const teamPageReducer = (state, action) => {
  switch (action.type) {
    case teamPageReducerTypes.foundTeamResult: {
      return {
        ...state,
        team: action.payload,
        pageMode: PresentationMode.Edit,
      };
    }
    case teamPageReducerTypes.setErrorData: {
      return {
        ...state,
        errorData: action.payload,
        pageMode: PresentationMode.Error,
      };
    }
    case teamPageReducerTypes.setOpenedModal: {
      return {
        ...state,
        openedModal: action.payload.modalType,
        modalAgent: action.payload.modalAgent ?? {},
      };
    }
    case teamPageReducerTypes.updateTeamInfo: {
      return { ...state, team: action.payload };
    }
    case teamPageReducerTypes.notFoundTeamResult: {
      return {
        ...state,
        openedModal: modalType.TeamInfo,
        pageMode: PresentationMode.Add,
        team: { codePrefix: state.errorData.argument },
        errorData: {},
      };
    }
    case teamPageReducerTypes.setDefaultAgent: {
      return {
        ...state,
        openedModal: modalType.None,
        team: action.payload,
      };
    }
    case teamPageReducerTypes.updateAddressInfo: {
      if (action.isModalOpenedOnTeamLevel) {
        return {
          ...state,
          team: { ...state.team, addresses: { postalAddress: action.address } },
        };
      } else {
        const agents = state.team.agents.map(agent => {
          if (agent.code === state.modalAgent.code) {
            return { ...agent, addressIsInherited: action.isInherited, address: action.address };
          } else {
            return agent;
          }
        });
        return {
          ...state,
          team: { ...state.team, agents },
        };
      }
    }
    case teamPageReducerTypes.updateStateAfterCreateTeam: {
      return { ...state, team: action.team, pageMode: PresentationMode.Edit };
    }
    case teamPageReducerTypes.deepLinkErrorPage: {
      return {
        ...state,
        openedModal: modalType.None,
        pageMode: PresentationMode.View,
        errorData: {},
      };
    }
    case teamPageReducerTypes.deepLinkErrorResult: {
      return {
        ...state,
        team: action.payload.team,
        errorData: action.payload.errorData,
        openedModal: modalType.None,
        pageMode: PresentationMode.Error,
      };
    }
    default: {
      throw Error('Unknown action.', action);
    }
  }
};
